import openFileInEditor from 'react-native/Libraries/Core/Devtools/openFileInEditor';

export default openFileInEditor;
